(function() {
    $(document).ready(function() {

        window.c24LpCssLoaded.then(function() {

            $('.mod24ContentHeader').each(function () {
                $('.headlinePlaceholder', this).remove();
                $('.contentText', this).css({
                    'margin-top': $('.headlineContainer', this).height() / 2,
                });

                const self = this;
                $(window).on('resize', function() {
                    $('.contentText', self).css({
                        'margin-top': $('.headlineContainer', self).height() / 2,
                    });
                });
            });
        });
    });
})();
